export const home_route = process.env.PUBLIC_URL + "/";

